export const fr = {
    cancel: "Annuler",
    close: "Fermer",
    ok: "Ok",
};
//# sourceMappingURL=fr.js.map